import * as FaIcons from "react-icons/fa";

import {
  ActivityIndicator,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native-web";
import {
  Avatar,
  ChatContainer,
  MainContainer,
  Message,
  MessageInput,
  MessageList,
} from "@chatscope/chat-ui-kit-react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { TableBody, TableCell, TableRow } from "@material-ui/core";

import { COLORS } from "constants/Colors";
import { CustomPicker } from "components/Inputs/CustomPicker";
import { FullModal } from "components/Modals/FullModal";
import { Links } from "constants/Links";
import { PrimaryText } from "components/Common/PrimaryText";
import Table from "components/Common/TableComponent/Table/Table";
import { archiveAdminChat } from "services/messages-service";
import loginLeft from "assets/images/loginLeft.jpg";
import moment from "moment";
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.css";
import styles2 from "./styles.css";
import { useMessages } from "context/MessagesContext";
import { useNavigate } from "react-router-dom";
import { useUsers } from "context/UserContext";
import { useDisplay } from "context/DisplayContext";

const pageSize = 10;

const options = [
  { value: "active", label: "Active" },
  { value: "archived", label: "Archived" },
];

export const MessagingList = () => {
  const navigate = useNavigate();
  const { isMobile, isSmallHeight, viewportHeight, viewportWidth } = useDisplay();

  const isCompact = isMobile || isSmallHeight;

  const {
    filteredChats,
    filter,
    setFilter,
    adminMessages,
    messagesLoading,
    selectedAdminChat,
    setSelectedAdminChat,
    sendText,
    loading: chatsLoading,
    setStartFetchGetAdminMessages,
  } = useMessages();
  const { nextPage, loading, setSelectedUser, selectedView } = useUsers();

  const [page, setPage] = useState(1);
  const [selectedItem, setSelectedItem] = useState(null);
  const [mobileView, setMobileView] = useState("list");
  const [chatHeight, setChatHeight] = useState(0);
  const [viewportOffset, setViewportOffset] = useState(0);
  const chatContainerRef = useRef(null);

  useEffect(() => {
    setStartFetchGetAdminMessages(true);
  }, []);

  useEffect(() => {
    if (isCompact && selectedAdminChat) {
      setMobileView("chat");
    }
  }, [isCompact, selectedAdminChat]);

  useEffect(() => {
    const handleResize = () => {
      if (window.visualViewport) {
        setChatHeight(window.visualViewport.height);
        setViewportOffset(window.visualViewport.offsetTop);
      } else {
        setChatHeight(window.innerHeight);
        setViewportOffset(0);
      }
    };

    handleResize();

    window.visualViewport?.addEventListener("resize", handleResize);
    window.visualViewport?.addEventListener("scroll", handleResize);
    window.addEventListener("resize", handleResize);

    return () => {
      window.visualViewport?.removeEventListener("resize", handleResize);
      window.visualViewport?.removeEventListener("scroll", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  function userSelected(user) {
    setSelectedUser(user);
    navigate(Links.UserDetail);
  }

  function archiveItem(value) {
    selectedItem.active = value;
    archiveAdminChat(selectedItem, value);
    const findIndex = filteredChats.findIndex((x) => x.id === selectedItem.id);
    filteredChats[findIndex] = selectedItem;
    setSelectedItem(null);
  }

  const chatSelected = useCallback(
    (item) => {
      setSelectedAdminChat(item);
      if (isCompact) {
        setMobileView("chat");
      }
    },
    [isCompact, setSelectedAdminChat]
  );

  const goBackToList = useCallback(() => {
    setMobileView("list");
    setSelectedAdminChat(null);
  }, [setSelectedAdminChat]);

  const currentTableData = () => {
    return filteredChats.sort((a, b) => {
      const aTime = a?.lastMessage?.lastUpdated?.toDate?.() ?? new Date(0);
      const bTime = b?.lastMessage?.lastUpdated?.toDate?.() ?? new Date(0);
      return aTime < bTime ? 1 : -1;
    });
  };

  function onSend(text) {
    sendText(text);
  }

  const totalCount = filteredChats?.length;
  const totalPageCount = Math.ceil(totalCount / pageSize);
  const startCount = (page - 1) * pageSize + 1;
  const endCount = startCount + currentTableData()?.length - 1;

  const showMobileChat = isCompact && mobileView === "chat";
  const showMobileList = isCompact && mobileView === "list";

  const renderChatPanel = () => (
    <View
      style={{
        flex: isCompact ? 1 : 3,
        width: isCompact ? "100%" : undefined,
        height: isCompact ? undefined : viewportHeight - 200,
        minHeight: 0,
      }}
    >
      {isCompact && (
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            paddingVertical: 8,
            paddingHorizontal: 4,
            borderBottomWidth: 1,
            borderBottomColor: COLORS.primary.lightGray,
            backgroundColor: COLORS.primary.white,
          }}
        >
          <TouchableOpacity style={{ padding: 8 }} onPress={goBackToList}>
            <FaIcons.FaArrowLeft size={18} color={COLORS.primary.darkGray} />
          </TouchableOpacity>
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              marginLeft: 8,
            }}
          >
            <img
              src={
                selectedAdminChat?.user?.defaultPic
                  ? selectedAdminChat?.user?.defaultPic
                  : loginLeft
              }
              style={{
                height: 32,
                width: 32,
                borderRadius: 16,
                objectFit: "cover",
              }}
            />
            <PrimaryText
              fontSize={15}
              fontWeight={600}
              style={{ marginLeft: 8 }}
            >
              {selectedAdminChat?.user?.firstName}{" "}
              {selectedAdminChat?.user?.lastName}
            </PrimaryText>
          </View>
        </View>
      )}
      {selectedAdminChat ? (
        messagesLoading ? (
          <View style={[ourStyles.emptyChatContainer, { flex: 1, minHeight: 0 }]}>
            <ActivityIndicator
              animating={true}
              size={"large"}
              color={COLORS.primary.blue}
            />
          </View>
        ) : adminMessages?.length > 0 ? (
          <div
            style={{
              position: "relative",
              flex: 1,
              minHeight: 0,
            }}
          >
            <MainContainer style={{ borderWidth: 0, borderLeftWidth: 1, height: "100%" }}>
              <ChatContainer>
                <MessageList>
                  {adminMessages?.map((item, index) => {
                    return (
                      <Message
                        key={index}
                        model={{
                          message: item.text,
                          direction:
                            item.user._id === "admin" ? "outgoing" : "incoming",
                        }}
                      >
                        <Message.Footer
                          style={{ display: "flex" }}
                          sender={item.user.name}
                          sentTime={moment(item.createdAt).format(
                            "MMM DD, hh:ss A"
                          )}
                        />
                        {item.user._id !== "admin" && (
                          <Avatar src={selectedAdminChat?.user?.defaultPic} />
                        )}
                      </Message>
                    );
                  })}
                </MessageList>
                <MessageInput
                  placeholder="Type message here"
                  attachButton={false}
                  onSend={onSend}
                />
              </ChatContainer>
            </MainContainer>
          </div>
        ) : (
          <View style={[ourStyles.emptyChatContainer, { flex: 1, minHeight: 0 }]}>
            <PrimaryText fontSize={18} fontWeight={600}>
              Conversation with {selectedAdminChat?.user?.firstName}{" "}
              {selectedAdminChat?.user?.lastName}
            </PrimaryText>
            <PrimaryText
              fontSize={14}
              fontWeight={400}
              style={{ marginTop: 8 }}
            >
              Write your first message to start the conversation
            </PrimaryText>
            <div
              style={{
                position: "relative",
                flex: 1,
                minHeight: 0,
                marginTop: 20,
                width: "100%",
              }}
            >
              <MainContainer style={{ borderWidth: 0, borderLeftWidth: 1, height: "100%" }}>
                <ChatContainer>
                  <MessageList></MessageList>
                  <MessageInput
                    placeholder="Type message here"
                    attachButton={false}
                    onSend={onSend}
                  />
                </ChatContainer>
              </MainContainer>
            </div>
          </View>
        )
      ) : (
        <View style={ourStyles.emptyChatContainer}>
          <div
            style={{
              flexDirection: "column",
              display: "flex",
              alignItems: "center",
            }}
          >
            <PrimaryText fontSize={18} fontWeight={600}>
              Select a user to start a conversation
            </PrimaryText>
            <PrimaryText
              fontSize={14}
              fontWeight={400}
              style={{ marginTop: 8 }}
            >
              Or go to "Start Chat" to search for users
            </PrimaryText>
            <div
              style={{
                flexDirection: "row",
                backgroundColor: COLORS.primary.darkBlue,
                justifyContent: "center",
                alignItems: "center",
                padding: 12,
                paddingHorizontal: 24,
                marginTop: 16,
                borderRadius: 6,
                cursor: "pointer",
              }}
              onClick={() => navigate(Links.StartChat)}
            >
              <PrimaryText
                fontSize={14}
                fontWeight={400}
                style={{
                  color: COLORS.primary.white,
                  marginLeft: 8,
                }}
              >
                Search users
              </PrimaryText>
            </div>
          </div>
        </View>
      )}
    </View>
  );

  if (chatsLoading) {
    return (
      <View
        style={{
          height: viewportHeight - 100,
          width: "100%",
          flexDirection: "column",
          backgroundColor: COLORS.primary.white,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <ActivityIndicator
          animating={true}
          size={"large"}
          style={StyleSheet.absoluteFill}
          color={COLORS.primary.blue}
        />
      </View>
    );
  }

  if (!currentTableData() || currentTableData()?.length === 0) {
    return (
      <View
        style={{
          flexDirection: "column",
          backgroundColor: COLORS.primary.white,
          alignItems: "center",
          paddingHorizontal: 24,
          marginTop: 12,
        }}
      >
        <View
          style={{
            flexDirection: isCompact ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isCompact ? "flex-start" : "center",
            width: "100%",
            marginBottom: 12,
          }}
        >
          <div className="flex-1" style={{ marginRight: 12 }} />
          <CustomPicker
            style={{ maxWidth: 175 }}
            mandatory
            value={filter}
            onChange={(value) => setFilter(value)}
            options={options}
          />
        </View>
        <View
          style={{
            height: viewportHeight - 200,
            width: "100%",
            flexDirection: "column",
            backgroundColor: COLORS.primary.white,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <PrimaryText fontSize={16} fontWeight={400}>
            {filter === "archived" ? "No archived conversations" : "No conversations yet"}
          </PrimaryText>
        </View>
      </View>
    );
  }

  return (
    <View style={[
      ourStyles.tableContainer,
      isCompact && {
        position: "fixed",
        top: viewportOffset,
        left: 0,
        right: 0,
        height: chatHeight,
        flexDirection: "column",
        padding: 8,
        overflow: "hidden",
      }
    ]}>
      {!showMobileChat && (
        <View
          style={{
            flexDirection: isCompact ? "column" : "row",
            justifyContent: "space-between",
            alignItems: isCompact ? "flex-start" : "center",
            paddingHorizontal: isCompact ? 8 : 24,
            marginTop: 12,
          }}
        >
          <div className="flex-1" style={{ marginRight: 12 }} />
          <CustomPicker
            style={{ maxWidth: 175 }}
            mandatory
            value={filter}
            onChange={(value) => setFilter(value)}
            options={options}
          />
        </View>
      )}
      {currentTableData() && (
        <View
          style={{
            flexDirection: isCompact ? "column" : "row",
            height: isCompact ? undefined : viewportHeight - 200,
            flex: isCompact ? 1 : undefined,
            minHeight: 0,
          }}
        >
          {(showMobileList || !isCompact) && (
            <View
              style={{
                flex: isCompact ? undefined : 2,
                width: isCompact ? "100%" : undefined,
                height: isCompact ? "100%" : undefined,
                overflowY: "auto",
                minWidth: 0,
              }}
            >
              <Table>
                <TableBody>
                  {currentTableData().map((item, index) => {
                    return (
                      <TableRow
                        hover
                        key={item.id}
                        onClick={() => chatSelected(item)}
                        selected={selectedAdminChat?.id === item?.id}
                        style={{
                          padding: 0,
                          margin: 0,
                          cursor: "pointer",
                        }}
                      >
                        <TableCell
                          style={{
                            minHeight: isCompact ? 60 : 50,
                            padding: 0,
                            margin: 0,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (isCompact) {
                              chatSelected(item);
                            } else {
                              userSelected(item.user);
                            }
                          }}
                        >
                          <img
                            src={
                              item.user.defaultPic
                                ? item.user.defaultPic
                                : loginLeft
                            }
                            style={{
                              height: isCompact ? 40 : 50,
                              width: isCompact ? 40 : 50,
                              borderRadius: isCompact ? 20 : 0,
                              objectFit: "cover",
                              padding: 0,
                              margin: 0,
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <View
                            style={{
                              flex: 1,
                              minWidth: 0,
                              overflow: "hidden",
                            }}
                          >
                            <PrimaryText fontSize={14} fontWeight={400}>
                              {item?.user?.firstName} {item?.user?.lastName}
                            </PrimaryText>
                            <PrimaryText
                              fontSize={14}
                              fontWeight={400}
                              numberOfLines={1}
                              style={{ width: "100%" }}
                            >
                              {item?.lastMessage?.text}
                            </PrimaryText>
                          </View>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </View>
          )}

          {(showMobileChat || !isCompact) && renderChatPanel()}
        </View>
      )}
      {!!selectedItem && (
        <FullModal
          setShowModal={() => setSelectedItem(null)}
          title={!!selectedItem?.active ? "Archive?" : "Unarchive?"}
        >
          <View style={ourStyles.modalContainer}>
            <TouchableOpacity
              style={ourStyles.button}
              onPress={() => archiveItem(!selectedItem?.active)}
            >
              <PrimaryText
                fontSize={16}
                fontWeight={400}
                style={{ color: COLORS.primary.white }}
              >
                Yes
              </PrimaryText>
            </TouchableOpacity>
          </View>
        </FullModal>
      )}
    </View>
  );
};

const ourStyles = StyleSheet.create({
  activity: {
    width: "100%",
    height: "100%",
    backgroundColor: COLORS.primary.white,
    position: "absolute",
    top: 0,
    bottom: 0,
    zIndex: 999,
  },
  tableContainer: {
    width: "100%",
  },
  button: {
    flexDirection: "row",
    backgroundColor: COLORS.primary.darkBlue,
    justifyContent: "center",
    alignItems: "center",
    padding: 8,
    paddingHorizontal: 24,
    margin: 12,
    borderRadius: 6,
  },
  modalContainer: {
    flex: 1,
    alignItems: "center",
    paddingVertical: 12,
  },
  emptyChatContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: COLORS.primary.white,
    padding: 24,
    width: "100%",
  },
});
